/**
 * @packageDocumentation
 * @module Array
 */
import { getPrefixedReducer } from '../others/reducers';
import { getFrom, setIn } from '../object';
/**
 * Sets a key in all objects in an array property of the values object passed.
 *
 * Useful for setting all lines in the formik state in components that do not have access to the financial
 * table state. (headers, etc). Performs a similar role to updateAvailableLines but not limited to operating
 * on LineState objects.
 *
 * @param values The object to update the value in.
 * @param recursionKey The the key to recurse down to find child objects.
 * @param newValue The value to set all keys in the values object to.
 * @param keyToSet The key to set newValue to.
 *
 * @return array of strings
 */
// eslint-disable-next-line max-params
export function setValueInChildArray(values, recursionKey, newValue, keyToSet) {
    var allLines = [];
    var value = getFrom(values, recursionKey);
    if (Array.isArray(value)) {
        allLines = value.reduce(getPrefixedReducer(recursionKey, recursionKey), allLines);
    }
    return allLines.reduce(function (acc, path) { return setIn(acc, path + "." + keyToSet, newValue); }, values);
}
//# sourceMappingURL=setValueInChildArray.js.map